module.exports = __webpack_public_path__ + "static/media/insPicThree.74610042.jpg";